import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import ToastNE from '../../../shared/components/ToastNE/ToastNE';
import { DEFAULT_TOAST_DATA } from '../../../shared/constants/toast';
import { IToast } from '../../../shared/interfaces/toast';
import SettingsPageLayoutNE from '../Layout/SettingsPageLayoutNE/SettingsPageLayoutNE';
import AvatarNE from './sections/Avatar/Avatar';
import LanguageSelector from './sections/LanguageSelector/LanguageSelector';
import Password from './sections/Password/Password';
import PersonalData from './sections/PersonalData/PersonalData';

import './SettingsAccount.scss';

const SettingsProfileNE = () => {
  const [toast, setToast] = useState<IToast>(DEFAULT_TOAST_DATA);
  const [isOpenToast, setIsOpenToast] = useState(false);

  const { t } = useTranslation();

  const handleOpenToast = (newToast: IToast) => {
    setToast(newToast);
    setIsOpenToast(true);
    setTimeout(() => handleCloseToast(), 5000);
  };

  const handleCloseToast = () => setIsOpenToast(false);

  return (
    <SettingsPageLayoutNE>
      <div className="settings-account-content">
        <div className="settings-avatar-container">
          <AvatarNE handleOpenToast={handleOpenToast} />
        </div>
        <div className="settings-form">
          <PersonalData handleOpenToast={handleOpenToast} />
          <div className="password-card">
            <Password />
          </div>
          <LanguageSelector handleOpenToast={handleOpenToast} />
        </div>
      </div>

      <ToastNE
        title={t(toast.title)}
        description={t(toast.description)}
        icon={toast.icon}
        open={isOpenToast}
        button={true}
        buttonText={t(toast.buttonText)}
        buttonAction={handleCloseToast}
        handleClose={handleCloseToast}
      />
    </SettingsPageLayoutNE>
  );
};

export default SettingsProfileNE;
